import React from 'react'

const Nodejs_Coding_Assignmet_2 = () => {
  return (
    <div>
      <h1>Assignment 2</h1>
    </div>
  )
}

export default Nodejs_Coding_Assignmet_2
